export default "__VITE_ASSET__DS6Jtk30__"